import * as THREE from 'three';
import { STLLoader } from 'three/addons/loaders/STLLoader.js';
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import { EffectComposer, RenderPass, UnrealBloomPass } from "three/addons";
import * as dat from "lil-gui";
import { gsap } from "gsap";

export class HeroWebGl
{
    constructor( pageLoader )
    {
        // Setup hole logic inside the constructor
        this.preload( pageLoader );
    }

    async preload( pageLoader )
    {
        // Preload
        // Note - we do it sequentially - okay for those we files - but could be improved ;-)
        this.assets = {};

        const rgbeLoader = new RGBELoader();
        this.assets.hdrEquirect = await rgbeLoader.loadAsync( '/assets/textures/rosendal_park_sunset_puresky_1k.hdr' );
        this.assets.hdrEquirect.mapping = THREE.EquirectangularReflectionMapping;
        pageLoader.onProgress();

        const stlLoader = new STLLoader();
        this.assets.iconGeometry = await stlLoader.loadAsync( '/assets/models/ahd-icon.svg_5mm.stl' );
        pageLoader.onProgress();

        this.setup( pageLoader );
        // Start the show
    }

    setup( pageLoader )
    {
        // Renderer
        const renderer = new THREE.WebGLRenderer(
            {
                canvas: document.querySelector( 'canvas.webgl'),
                antialias: true
            }
        );
        renderer.setClearColor( 0xffffff, 1);
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( window.innerWidth, window.innerHeight );
        renderer.toneMapping = THREE.ReinhardToneMapping;
        renderer.toneMappingExposure = 0.5;

        // Scene
        const scene = new THREE.Scene();
        scene.environment = this.assets.hdrEquirect;

        // Main Icon group
        const iconGroup = new THREE.Group();
        scene.add( iconGroup );

        // const pointlight1 = new THREE.PointLight (0x85ccb8, 2.5, 20);
        // pointlight1.position.set (0,3,2);
        // iconGroup.add ( pointlight1 );

        // const pointlight2 = new THREE.PointLight (0x9f85cc, 2.5, 20);
        // pointlight2.position.set (0,3,2);
        //iconGroup.add ( pointlight2 );

        var camera = new THREE.PerspectiveCamera( 45, window.innerWidth/window.innerHeight, 0.1, 1000 );
        iconGroup.add( camera );
        let cameraDestPosititionZ = 6;
        camera.position.z = 0;
        camera.position.y = 10;
        camera.position.x = 10;

        const iconMaterial = new THREE.MeshStandardMaterial({
            envMap: this.assets.hdrEquirect,
            envMapIntensity: 0.115,
            flatShading: false,
            color : 0x60abff
        });

        const iconMesh = new THREE.Mesh( this.assets.iconGeometry, iconMaterial );
        iconMesh.geometry.center();
        iconMesh.position.set( 0.0, 0.1, 0 );
        iconMesh.scale.set( 0.06, 0.06, 0.06 );
        iconGroup.add( iconMesh );

        // POST PROCESSING

        // define/add the RenderPass
        const renderScene = new RenderPass( scene, camera );

        // add a new UnrealBloomPass and add the values from the parameters above
        const bloomPass = new UnrealBloomPass(
            new THREE.Vector2( window.innerWidth, window.innerHeight ),
                .5,
            0.5,
            0.1
        );

        // finally, create a new EffectComposer and add the different effects
        const composer = new EffectComposer( renderer );
        composer.addPass( renderScene );
        composer.addPass( bloomPass );

        // Debug
        if ( location.hostname === "localhost" || location.hostname === "127.0.0.1" )
        {
            // const debugObject = {};
            // const gui = new dat.GUI()
            //
            // const guiFolderCamera = gui.addFolder( 'Camera' );
            // guiFolderCamera.add( camera.position, 'x').min(- 10).max(10).step(0.001).name('PositionX');
            // guiFolderCamera.add( camera.position, 'y').min(- 10).max(10).step(0.001).name('PositionY');
            // guiFolderCamera.add( camera.position, 'z').min(- 10).max(10).step(0.001).name('PositionZ');
            //
            // const guiIconGroup = gui.addFolder( 'IconGroup' );
            // guiIconGroup.add( iconGroup.rotation, 'x').min(- 10).max(10).step(0.001).name('RotationX');
            // guiIconGroup.add( iconGroup.rotation, 'y').min(- 10).max(10).step(0.001).name('RotationY');
            // guiIconGroup.add( iconGroup.rotation, 'z').min(- 10).max(10).step(0.001).name('RotationZ');
            // guiIconGroup.add( iconMaterial, 'envMapIntensity' ).min( 0 ).max( 1 ).step( 0.001 ).name( 'Envmap Intensity' );
            //
            // const guiBloomFX = gui.addFolder( 'BloomFX' );
            // guiBloomFX.add( bloomPass, "radius" ).min( 0 ).max( 1 ).step( 0.001 ).name( "Radius" );
            // guiBloomFX.add( bloomPass, "strength" ).min( 0 ).max( 3 ).step( 0.001 ).name( "Strength" );
            // guiBloomFX.add( bloomPass, "threshold" ).min( 0 ).max( 1 ).step( 0.001 ).name( "Threshold" );
            // guiBloomFX.add( renderer, "toneMappingExposure" ).min( 0 ).max( 1 ).step( 0.001 ).name( "ToneMapping Exposure" );
            //
            // const guiFolderLights = gui.addFolder( 'Lights' );
            // guiFolderLights.add( pointlight1, 'intensity').min(0).max(10).step(0.001).name('Light1 Intensity');
            // guiFolderLights.add( pointlight1, 'distance').min(0).max(10).step(0.001).name('Light1 Distance');
            // guiFolderLights.addColor( pointlight1, 'color').name('Light1 Color');
            // guiFolderLights.add( pointlight1.position, 'x').min(- 10).max(10).step(0.001).name('Light1 PositionX');
            // guiFolderLights.add( pointlight1.position, 'y').min(- 10).max(10).step(0.001).name('Light1 PositionY');
            // guiFolderLights.add( pointlight1.position, 'z').min(- 10).max(10).step(0.001).name('Light1 PositionZ');
            //
            // guiFolderLights.add( pointlight2, 'intensity').min(0).max(10).step(0.001).name('Light2 Intensity');
            // guiFolderLights.add( pointlight2, 'distance').min(0).max(10).step(0.001).name('Light2 Distance');
            // guiFolderLights.addColor( pointlight2, 'color').name('Light2 Color');
            // guiFolderLights.add( pointlight2.position, 'x').min(- 10).max(10).step(0.001).name('Light2 PositionX');
            // guiFolderLights.add( pointlight2.position, 'y').min(- 10).max(10).step(0.001).name('Light2 PositionY');
            // guiFolderLights.add( pointlight2.position, 'z').min(- 10).max(10).step(0.001).name('Light2 PositionZ');
            // guiFolderLights.close();

            /*
            gui.add(directionalLight, 'castShadow')
            gui.add(directionalLight.shadow, 'normalBias').min(- 0.05).max(0.05).step(0.001)
            gui.add(directionalLight.shadow, 'bias').min(- 0.05).max(0.05).step(0.001)
             */

        }

        // Interactivity
        const mousePos = { x : 0, y : 0 };
        const onDocumentMouseMove = (event) =>
        {
            mousePos.x = (event.clientX / window.innerWidth - 0.5) * 4;
            mousePos.y = (event.clientY / window.innerHeight - 0.5) * 4;
        };
        document.addEventListener("pointermove", onDocumentMouseMove, false);


        // RESIZE
        window.addEventListener( 'resize', onWindowResize );

        let theta1 = 0;

        // create a new update function for the animations
        const update = function()
        {
            theta1 += 0.0025;

            // create a panning animation for the camera
            // camera.position.x = Math.sin( theta1 ) * 8;
            // camera.position.z = Math.cos( theta1 ) * 8;
            // camera.position.y = 2.5 * Math.cos( theta1 ) + 2;

            camera.position.y += lerp( camera.position.y, mousePos.y );
            camera.position.x += lerp( camera.position.x, -mousePos.x );
            camera.position.z += lerp( camera.position.z, cameraDestPosititionZ );

            // camera.position.x = 2;
            // camera.position.y = 4;
            // camera.position.z = 6;

            // pointlight1.position.x = Math.sin( theta1+1 ) * 11;
            // pointlight1.position.z = Math.cos( theta1+1 ) * 11;
            // pointlight1.position.y = 2 * Math.cos( theta1-3 ) +3;
            //
            // pointlight2.position.x = -Math.sin( theta1+1 ) * 11;
            // pointlight2.position.z = -Math.cos( theta1+1 ) * 11;
            // pointlight2.position.y = 2 * -Math.cos( theta1-3 ) -6;

            // rotate the group to simulate the rotation of the HDR
            //iconGroup.rotation.y += 0.006;


            // keep the camera look at 0,0,0
            camera.lookAt( 0, 0, 0 );
        }


        function lerp( current, target )
        {
            return ( target - current ) * .01;
        }

        function onWindowResize()
        {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize( window.innerWidth, window.innerHeight );

            if ( window.innerWidth > window.innerHeight )
            {
                iconMesh.scale.set( .06, .06, .06 );
            }
            else
            {
                iconMesh.scale.set( .021, .021, .021 );
            }
        }

        this.animate = () =>
        {
            update();
            composer.render();
            requestAnimationFrame(this.animate);
        };

        gsap.to( '#leistungen', {
            scrollTrigger : {
                trigger : "#home",
                start: '0%',
                markers: false,
                onUpdate: ( self ) => {
                    cameraDestPosititionZ = 6 - ( 6 * self.progress );
                },

                onEnterBack : () => {
                    scene.visible = true;
                },

                onLeave: () => {
                    scene.visible = false;
                }
            }
        });

        // Start
        onWindowResize();
        pageLoader.onProgress();
    }

    run()
    {
        requestAnimationFrame( this.animate )
    }
}
